import { useSubscriptionStatus } from "@hooks/use-current-user";
import { subscriptionStatuses } from "@utils/constants/subscriptionStatuses";
import SubscriptionCancelationAskNew from "./SubscriptionCancelationAskNew";
import SubscriptionCancelationAlreadyAsked from "./SubscriptionCancelationAlreadyAsked";
import SubscriptionCanceled from "./SubscriptionCanceled";

function SubscriptionCancelation({ currentCoupon }) {
  const subscriptionStatus = useSubscriptionStatus();

  switch (subscriptionStatus) {
    case subscriptionStatuses.subscribed:
      return <SubscriptionCancelationAskNew currentCoupon={currentCoupon} />;
    case subscriptionStatuses.subscribedWaitingForCancelation:
    case subscriptionStatuses.subscribedWaitingForCancelationBlockedByCloset:
    case subscriptionStatuses.pastDueWaitingForCancelation:
      return <SubscriptionCancelationAlreadyAsked />;
    case subscriptionStatuses.canceled:
      return <SubscriptionCanceled />;
    default:
      return null;
  }
}

export default SubscriptionCancelation;
